import { Record } from "immutable";
import { StoreKeyType } from "../delivera/interface";

export interface ServiceInterface {
    locationId: string | undefined,
    isActive: boolean,
    uid: string | undefined,
    service: StoreKeyType,
    name: string,
    last_updates: any[],
    accessToken?: string,
    refreshToken?: string,
    accountId?: string,
    accountName?: string,
    catalogId?: string,
    catalogName?: string,
    customerListId?: string,
    customerListName?: string
    locationName?: string,
    franchiseName?: string
    signatureKey?: string
    listenerId?: string
    shopToken?: string
    franchiseToken?: string
}

const defaultServiceProps: ServiceInterface = {
    locationId: "",
    isActive: false,
    uid: "",
    service: "ubereats",
    name: "test_shop",
    last_updates: [],
    accessToken: "",
    refreshToken: "",
    accountId: "",
    catalogId: "",
    catalogName: "",
    customerListId: "",
    customerListName: "",
    locationName: "",
    accountName: "",
    franchiseName: "",
    signatureKey: "",
    listenerId: "",
    shopToken: "",
    franchiseToken: ""
}

export default class Service extends Record(defaultServiceProps) implements ServiceInterface {
    // constructor(props: any) {
    //     console.log(props);
    //     super(props);
    // }
    public get actived(): boolean {
        return this.isActive && this.locationId !== undefined && this.locationId !== null && this.locationId.length !== 0;
    }
}